import { BaseFormula } from "../../BaseFormula";
import { CalculationResult } from "../../CalculationResult";
import { ChangeType } from "../../ChangeType";
import { CostData } from "../../CostData";

export class Formula_AmountByLast extends BaseFormula
{
    evaluate(data: CostData[], value: CostData, change: ChangeType, parameters: { threshold: number }): CalculationResult
    {
        if (data.length == 0)
            return {
                value: true,
                reason: "New Cost",
                values: {}
            };

        let last = data[data.length - 1];
        let difference = value.amount - last.amount;

        let err = this.checkChnage(change, difference, { last, difference });
        if (err)
            return err;

        return {
            value: Math.abs(difference) >= parameters.threshold,
            values: { last: last.amount, difference }
        };
    }
}